import { recordErrorSpan } from 'utils/telemetry/errors'

type MonitoringUser = {
  id?: string
  email?: string
  [key: string]: unknown
}

const isDev = process.env.NODE_ENV === 'development'

export const monitoring = {
  addError(error: unknown, context?: unknown): void {
    recordErrorSpan(error, context)

    if (isDev) {
      console.error('[monitoring]', error, context)
      return
    }
    console.error(
      error instanceof Error ? error.message : String(error),
      context
    )
  },

  setUser(user: MonitoringUser): void {
    if (isDev) {
      console.debug('[monitoring] setUser', { id: user.id, email: user.email })
    }
  }
}
